import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";

import { text } from "../text";
import { hooks } from "../hooks";
import { utils } from "../utils";
import { theme } from "../constants";
import { components } from "../components";

export const Onboarding: React.FC = () => {
  const location = useLocation();
  const { pathname } = useLocation();

  const navigate = hooks.useNavigate();

  const [activeIndex, setActiveIndex] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel();

  const handleSlideChange = () => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.scroll({ top: -1, left: 0, behavior: "smooth" });
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (location.pathname.includes("Onboarding")) {
      metaThemeColor?.setAttribute("content", "#040325");
    } else {
      metaThemeColor?.setAttribute("content", "#ffffff");
    }
  }, [location]);

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on("select", handleSlideChange);
    }
  }, [emblaApi]);
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/home");
    }, 400);
    return () => clearTimeout(timer);
  }, [navigate]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        minHeight: "100vh", // Ensure it takes full height of the viewport
        background:
          "linear-gradient(318.06deg, var(--secondary-color) -5.06%, var(--primary-color) 54.36%)", // Background gradient
        // background: 'linear-gradient(318.06deg, #403A8A -5.06%, #7065F0 54.36%)', // Background gradient
        padding: 0,
      }}
    >
      {/* <img src={require('../assets/nestfin/applogo.png')} /> */}
      {/* <img src={require('../assets/nestfin/NexfinPng.png')} /> */}
      <img
        src={require("../assets/nestfin/Nestfin Logo_white.png")}
        className="home-page-logo-image"
        style={{
          maxWidth: "300px",
        }}
      />
      {/* {renderHeader()} */}
    </div>
  );
};
